import { render, staticRenderFns } from "./bottom-tab.vue?vue&type=template&id=147fe7be&scoped=true&"
import script from "./bottom-tab.vue?vue&type=script&lang=ts&"
export * from "./bottom-tab.vue?vue&type=script&lang=ts&"
import style0 from "./bottom-tab.vue?vue&type=style&index=0&id=147fe7be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147fe7be",
  null
  
)

export default component.exports